import moment from 'moment';

import * as actions from './actions';
import * as getters from './getters';

import {
    CLEAR_SEARCH,
    FETCH_COUNTRIES,
    SET_COUNTRY,
    FETCH_LOCATIONS,
    SET_PROMO_CODE,
    SET_DRIVER_AGE,
    SET_PASSENGERS,
    SET_TRANSMISSION,
    SET_DROPOFF_DIFFERENT,
    SET_DROPOFF_LOCATION,
    SET_PICKUP_DATE,
    SET_PICKUP_TIME,
    SET_DROPOFF_DATE,
    SET_DROPOFF_TIME,
    SET_PICKUP_LOCATION,
    SET_SEARCH_STATE,
    SET_GUEST_TOKEN,
    SET_QUOTE_ID,
    SET_CURRENCY,
    SET_AGENT_ID,
    SET_CORPORATE_POA,
    SET_CORPORATE_CREDIT,
} from './mutation-types';

const tomorrow = moment().add(1, 'days');
const dayAfterTomorrow = tomorrow.clone().add(1, 'days');

window.greenmotion = window.greenmotion || {};
let config = Object.assign(
    { currency: null, guestToken: null, userToken: null },
    JSON.parse(localStorage.getItem('HTTP'))
);
// initial state
const initialState = {
    search: {
        country: null,
        currency: config.currency,
        driverAge: 30,
        dropoffDate: dayAfterTomorrow.format('YYYY-MM-DD'),
        dropoffDifferent: false,
        dropoffLocation: null,
        dropoffTime: '09:00',
        guestToken: config.guestToken,
        location: null,
        passengers: '',
        pickupDate: tomorrow.format('YYYY-MM-DD'),
        pickupLocation: null,
        pickupTime: '09:00',
        promoCode: '',
        quoteId: null,
        transmission: '',
        agentId: null,
        corporatePoa: false,
        corporateCredit: false,
    },
    initialLocation: window.greenmotion.location_id || null,
    layout: window.greenmotion.layout || 'standard',
    countries: [],
    locations: [],
};

// mutations
const mutations = {
    [FETCH_COUNTRIES](state, countries) {
        state.countries = countries;
    },

    [SET_COUNTRY](state, country) {
        state.search.country = country;
    },

    [FETCH_LOCATIONS](state, locations) {
        state.locations = locations;
    },

    [SET_PROMO_CODE](state, code) {
        state.search.promoCode = code;
    },

    [SET_DRIVER_AGE](state, age) {
        state.search.driverAge = age;
    },

    [SET_PASSENGERS](state, passengers) {
        state.search.passengers = passengers;
    },

    [SET_TRANSMISSION](state, transmission) {
        state.search.transmission = transmission;
    },

    [SET_DROPOFF_DIFFERENT](state, different) {
        state.search.dropoffDifferent = different;
    },

    [SET_DROPOFF_LOCATION](state, different) {
        state.search.dropoffLocation = different;
    },

    [SET_PICKUP_DATE](state, date) {
        state.search.pickupDate = moment(date).format('YYYY-MM-DD');
    },

    [SET_PICKUP_TIME](state, time) {
        state.search.pickupTime = time;
    },

    [SET_DROPOFF_DATE](state, date) {
        state.search.dropoffDate = moment(date).format('YYYY-MM-DD');
    },

    [SET_DROPOFF_TIME](state, time) {
        state.search.dropoffTime = time;
    },

    [SET_PICKUP_LOCATION](state, location) {
        state.search.pickupLocation = location;
    },

    [SET_DROPOFF_LOCATION](state, location) {
        state.search.dropoffLocation = location;
    },

    [SET_SEARCH_STATE](state, payload) {
        state.search[payload.key] = payload.value;
    },

    [SET_AGENT_ID](state, agentId) {
        state.search.agentId = agentId;
    },

    [SET_CORPORATE_POA](state, corporatePoa) {
        state.search.corporatePoa = corporatePoa;
    },

    [SET_CORPORATE_CREDIT](state, corporateCredit) {
        state.search.corporateCredit = corporateCredit;
    },

    [SET_QUOTE_ID](state, id) {
        state.search.quoteId = id;
    },

    [SET_CURRENCY](state, currency) {
        state.search.currency = currency;
    },

    [SET_GUEST_TOKEN](state, token) {
        state.search.guestToken = token;
    },

    [CLEAR_SEARCH](state) {
        state.search = initialState.search;
    },
};

export default {
    state: { ...initialState },
    actions,
    getters,
    mutations,
};
